<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .temporary-candidate-options {
    &:not(.dummy) {
      margin-top: utils.in_rem(32px);
    }

    &.dummy {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(12px);
      align-content: center;
      justify-content: center;
      height: 100%;

      .text {
        @include mixins.body2();
        @include colors.color(textBlack);
        text-align: center;
      }
    }

    .options {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(2px);
    }
  }
</style>

<script>
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import {
    activePopUpModalStore,
    disableAddToContactStore,
    showEditContact,
    todosModalItemStore,
  } from "../stores";

  let { dummyCandidate = false } = $props();

  const onclickAddNew = () => {
    $showEditContact = true;
  };

  const onclickAddExisting = () => {
    $activePopUpModalStore = {
      modal: "assignToContact",
      toDoId: $todosModalItemStore.toDoId,
      onclose: () => activePopUpModalStore.set(null),
      onclickAdd: () => {
        $disableAddToContactStore = true;
      },
    };
  };

  let buttonText = $derived(
    dummyCandidate ? "Associate task with a contact" : "Add to contacts"
  );

  let disabled = $derived($disableAddToContactStore);
</script>

<div class="temporary-candidate-options" class:dummy={dummyCandidate}>
  <Dropdown
    size="large"
    kind={dummyCandidate ? "tertiary" : "secondary"}
    leadingIcon="far fa-user-plus"
    trailingIcon=""
    style="width: 100%;"
    {disabled}
  >
    <div slot="button">{buttonText}</div>
    <div class="options">
      <ListItem icon="far fa-user-plus" onclick={onclickAddNew}
        >Add new contact</ListItem
      >
      <ListItem icon="far fa-user" onclick={onclickAddExisting}
        >Assign to existing contact</ListItem
      >
    </div>
  </Dropdown>
  {#if dummyCandidate}
    <span class="text"
      >We couldn't associate this task to a contact in SourceWhale.</span
    >
  {/if}
</div>
